import type { PullQuoteBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface PullQuoteBlockEditorProps {
  content: PullQuoteBlockContent | null
  onChange: (content: PullQuoteBlockContent) => void
}

export function PullQuoteBlockEditor({
  content,
  onChange,
}: PullQuoteBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<PullQuoteBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Pull Quote</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Quote</Label>
          <Textarea
            value={c.quote ?? ""}
            onChange={(e) => update({ quote: e.target.value })}
            placeholder="Featured quote text"
            rows={3}
            className="resize-none"
          />
        </div>
        <div>
          <Label>Attribution</Label>
          <Input
            value={c.attribution ?? ""}
            onChange={(e) => update({ attribution: e.target.value })}
            placeholder="— Author Name"
          />
        </div>
      </CardContent>
    </Card>
  )
}
